import log from 'loglevel';

const LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL || 'info';
log.setLevel(LOG_LEVEL);

// Define and export the logger
const logger = {
  trace: (...args) => log.trace(...args),
  debug: (...args) => log.debug(...args),
  info: (...args) => log.info(...args),
  warn: (...args) => log.warn(...args),
  error: (...args) => log.error(...args),
};

export default logger;
